// extracted by mini-css-extract-plugin
export var choices = "choices-module--choices--1FkR9";
export var choice = "choices-module--choice--2F81l";
export var label = "choices-module--label--1qzMP";
export var selected = "choices-module--selected--16Eze";
export var radio = "choices-module--radio--2LbBO";